
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-rewards",
      function () {
        return require("private-next-pages/referral-rewards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-rewards"])
      });
    }
  